import * as intercom_methods from "@intercom/messenger-js-sdk"
import { merge } from "@pdfking/rfunc"

import register_dom_update from "../../navigation/register_dom_update"
import user from "../../state/user"

let resolve = null

const promise = new Promise(r => (resolve = r))

const intercom_cmd = (cmd, ...args) =>
  promise.then(i => intercom_methods[cmd](...args))

const intercom_update = payload => {
  if (user.is_staff) {
    intercom_cmd("shutdown")
  } else {
    intercom_cmd(
      "update",
      merge(
        {
          email: user.email,
          name: user.name,
          user_id: user.id,
        },
        payload
      )
    )
  }
}

const intercom_shutdown = () => intercom_cmd("shutdown")

const intercom_track = (...args) => {
  intercom_cmd("trackEvent", ...args)
  intercom_update()
}

const make_post_registration_handler = name => (e, event) => {
  if (!event.detail.initial) {
    //intercom_shutdown()
    intercom_track(name, {})
  }
}

register_dom_update({
  login: make_post_registration_handler("login"),
  logout: make_post_registration_handler("logout"),
  signup: make_post_registration_handler("signup"),
})

export default {
  load: app_id => resolve(intercom_methods.Intercom({ app_id })),
  shutdown: intercom_shutdown,
  track: intercom_track,
  update: intercom_update,
}
